import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-c-chica-consulta-mov-fondo",
  templateUrl: "./c-chica-consulta-mov-fondo.component.html",
  styleUrls: ["./c-chica-consulta-mov-fondo.component.scss"],
})
export class CChicaConsultaMovFondoComponent implements OnInit {
  constructor() {}

  optionsEstado: Array<any> = [];

  ngOnInit() {
    this.optionsEstado = [
      { value: "1", label: "Pendiente" },
      { value: "2", label: "Estado 2" },
      { value: "3", label: "Estado 3" },
    ];
  }
}
